import PropTypes from 'prop-types';

import {
  itinerarySideBarPropTypes,
  progressBarStepPropTypes,
  selectedOptionsPropTypes,
} from '../../../propTypes';

export const labelsPropTypes = PropTypes.shape({
  expiredLabel: PropTypes.string,
  expiresLabel: PropTypes.string,
  expiresText: PropTypes.string,
  transactionAmountLabel: PropTypes.string,
  transactionReferenceLabel: PropTypes.string,
});

export const paymentLoadPropTypes = PropTypes.shape({
  errorCode: PropTypes.number,
  errorMessage: PropTypes.string,
  itinerarySideBar: itinerarySideBarPropTypes,
  paxCapLimitReached: PropTypes.bool,
  price: PropTypes.number,
  progressBarSteps: PropTypes.arrayOf(progressBarStepPropTypes),
  selectedOptions: selectedOptionsPropTypes,
  tourDescription: PropTypes.string,
  tourFromDate: PropTypes.string,
  tourName: PropTypes.string,
  tournamentName: PropTypes.string,
  tourSoldOut: PropTypes.bool,
  tourToDate: PropTypes.string,
});
